export default "__VITE_ASSET__CxckkEvl__"